import styled, { createGlobalStyle } from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII, SHADOWS } from 'styles/consts'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const FixedPlusWrapper = styled.div`
  position: sticky;
  top: 0;
  right: 20px;
  z-index: 10;
  pointer-events: none;
  margin-left: 20px;
`

export const PlusButtonWrapper = styled.button`
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: ${RADII.field};
  border: none;
  background: ${COLORS.primary};
  box-shadow: ${SHADOWS.card};
  transition: background 0.2s ease;
  cursor: pointer;

  &:hover {
    background: ${COLORS.primaryHover};
  }

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    width: 40px;
    height: 40px;
    padding: 10px;
  }
`

export const PlusButtonGlobalStyles = createGlobalStyle`
  .plus-button-flyout {
    border-radius: ${RADII.card}
  }
`
